import { useEffect } from 'react';
import Mc0655LimitUsageSection from '../mc0655-limit-usage/Mc0655LimitUsageSection';
import { logExposure } from '../../utils/laboratoryClient';
import { MC0655_TREATMENT_KEY } from '../../constants/experimentKeys';
import FeatureInterestAndLimitUsageSection from '../feature-interest/FeatureInterestAndLimitUsageSection';
import { jsx as _jsx } from "react/jsx-runtime";
const LimitSection = ({
  isFreePortal,
  isInTrial,
  isInMC0655Variant
}) => {
  useEffect(() => {
    if (isFreePortal && isInTrial === false) {
      logExposure(MC0655_TREATMENT_KEY);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (isFreePortal) {
    if (isInMC0655Variant && isInTrial === false) {
      return /*#__PURE__*/_jsx(Mc0655LimitUsageSection, {});
    }
    return /*#__PURE__*/_jsx(FeatureInterestAndLimitUsageSection, {});
  }
  return null;
};
export default LimitSection;